import { render, staticRenderFns } from "./Block6Item.vue?vue&type=template&id=e40da8fa&scoped=true&"
import script from "./Block6Item.vue?vue&type=script&lang=js&"
export * from "./Block6Item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e40da8fa",
  null
  
)

export default component.exports